import { useQuery } from "@tanstack/react-query";
import { DeclarationActiviteApi } from "../declaration-activite.api";
import { declarationActiviteKeys } from "../declaration-activite.keys";

export function useDeclarationActiviteIobspAdminQuery(
  siren: string | undefined,
  millesime: number | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: declarationActiviteKeys.admin(
      siren ?? "",
      millesime ?? 0,
      "iobsp"
    ),
    queryFn: () => DeclarationActiviteApi.getIobspAdmin(siren!, millesime!),
    enabled: Boolean(siren && millesime) && enabled,
    staleTime: 30_000,
  });
}
